(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/details/competition-details.js');
"use strict";

const HighscoreListType = svs.components.marketplaceCompetition.services.constants.highscoreConstants.HighscoreListType;
const _svs$components$marke = svs.components.marketplaceCompetition.routeResult.details,
  CompetitionDetailsIndividual = _svs$components$marke.CompetitionDetailsIndividual,
  CompetitionDetailsTeams = _svs$components$marke.CompetitionDetailsTeams;
const CompetitionDetails = _ref => {
  let _ref$drawResults = _ref.drawResults,
    drawResults = _ref$drawResults === void 0 ? [] : _ref$drawResults,
    type = _ref.type,
    numberOfDraws = _ref.numberOfDraws;
  const isTeamDetails = type === HighscoreListType.Team;
  return React.createElement(React.Fragment, null, isTeamDetails && React.createElement(CompetitionDetailsTeams, {
    drawResults: drawResults,
    isTeamDetails: isTeamDetails
  }), !isTeamDetails && React.createElement(CompetitionDetailsIndividual, {
    drawResults: drawResults,
    numberOfDraws: numberOfDraws
  }));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.details.CompetitionDetails', CompetitionDetails);

 })(window);